import config from './chars.config';

/**
 * CharsService class.
 * Use this service to get usefull information about char.
 */
export default class CharsService {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @constructor
     * @ngInject
     */
    constructor() {
        this.data = config.data;
    }

    /**
     * Get list of coordinates
     * @returns {Object} Return all coordinates configs
     */
    getList() {
        return this.data;
    }

    /**
     * Get char information
     * @param {string} char - Char symbol
     * @returns {{}|null} Return char config or null if absent
     */
    getChar(char) {
        return this.data[char] || null;
    }
}



// WEBPACK FOOTER //
// ./app/services/chars/chars.service.js